module.exports = __webpack_public_path__ + "img/arrow_up_circle.4a87482f.svg";